import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=566d2cc6&scoped=true&"
import script from "./Section4.vue?vue&type=script&lang=js&"
export * from "./Section4.vue?vue&type=script&lang=js&"
import style0 from "./Section4.vue?vue&type=style&index=0&id=566d2cc6&prod&lang=less&scoped=true&"
import style1 from "./Section4.vue?vue&type=style&index=1&id=566d2cc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566d2cc6",
  null
  
)

export default component.exports